import { VRM_CHECK_CODES } from 'Utilities/vrm';

export const errorCodesToCheck = [
  VRM_CHECK_CODES.BAD_REQUEST,
  VRM_CHECK_CODES.EXCEEDED,
  VRM_CHECK_CODES.TOO_MANY_REQUESTS,
  VRM_CHECK_CODES.VEHICLE_GENERATION_FAILURE,
] as const;

export type CheckableErrorCode = typeof errorCodesToCheck[number];
